export default __webpack_public_path__ + "static/crab-2da8571b9f7461730206b171f0e18523.png";